import React from 'react';
import { useIntl } from 'react-intl';
import { Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter, infoFormatter, infoFormatterIntl, userFIOFormatter,
} from '../../../utils/formatters';
import { USER_TYPE, USER_TYPE_LIST } from '../../../configs';

export default function RecipientView(props) {
  const {
    current, isSZLT = false, isVehicle = false, formMeta,
  } = props;
  const { formatMessage } = useIntl();
  const entityType = USER_TYPE_LIST.find(f => f.value === current.legal_entity_type);
  return (
    <>
      <div className="f4 mt-3">{isSZLT ? 'СЗЛТ' : isVehicle ? 'Владелец' : 'Получатель услуги'}</div>
      <Row className="row-cols-1">
        {infoFormatterIntl('legal_entity_type', formatMessage({ id: entityType ? entityType.nameId : 'no.data.available' }), formMeta, 'legal_entity_type')}
      </Row>
      {current.legal_entity_type === USER_TYPE.LEGAL ? (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl('legal_entity_form', current.legal_entity_form, formMeta, 'legal_entity_form')}
            {infoFormatterIntl('short_name_legal', current.short_name, formMeta, 'short_name')}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl('full_name_legal', current.full_name, formMeta, 'full_name')}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl('address', current.address, formMeta, 'address')}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl('legal_address', current.legal_address, formMeta, 'legal_address')}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('inn', current.inn, formMeta, 'inn')}
            {infoFormatterIntl('ogrn', current.ogrn, formMeta, 'ogrn')}
          </Row>
          <Row className="row-cols-2">
            {infoFormatter('ФИО руководителя', userFIOFormatter(current), formMeta, ['last_name', 'first_name', 'middle_name'])}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('phone', current.phone, formMeta, 'phone')}
            {infoFormatterIntl('pd.email', current.email, formMeta, 'email')}
          </Row>
        </>
      ) : (
        <>
          <Row className="row-cols-1">
            {infoFormatterIntl('inn', current.inn, formMeta, 'inn')}
          </Row>
          <Row className="row-cols-1">
            {infoFormatter('ФИО', userFIOFormatter(current), formMeta, ['last_name', 'first_name', 'middle_name'])}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('birth_date', dateFormatter(current.birth_date), formMeta, 'birth_date')}
            {infoFormatterIntl('place_of_birth', current.place_of_birth, formMeta, 'place_of_birth')}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('gender', formatMessage({ id: `gender.${current.gender}` }), formMeta, 'gender')}
            {infoFormatterIntl('citizenship', formatMessage({ id: `citizenship.type.${current.citizenship}` }), formMeta, 'citizenship')}
          </Row>
          <Row className={current.legal_entity_type === 2 ? 'row-cols-3' : 'row-cols-2'}>
            {infoFormatterIntl('snils', current.snils, formMeta, 'snils')}
            {current.legal_entity_type === 2 ? infoFormatterIntl('ogrnip', current.ogrn, formMeta, 'ogrn') : null}
            {infoFormatterIntl('registration_type', formatMessage({ id: `registration.type.${current.registration_type}` }), formMeta, 'registration_type')}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('phone', current.phone, formMeta, 'phone')}
            {infoFormatterIntl('pd.email', current.email, formMeta, 'email')}
          </Row>
          <Row className="row-cols-3">
            {infoFormatterIntl('identity_type', formatMessage({ id: `identity.type.${current.identity_type}` }), formMeta, 'identity_type')}
            {infoFormatterIntl('identity_series', current.identity_series, formMeta, 'identity_series')}
            {infoFormatterIntl('identity_number', current.identity_number, formMeta, 'identity_number')}
          </Row>
          <Row className="row-cols-3">
            {infoFormatterIntl('identity_issue_date', dateFormatter(current.identity_issue_date), formMeta, 'identity_issue_date')}
            {infoFormatterIntl('identity_issuer', current.identity_issuer, formMeta, 'identity_issuer')}
          </Row>
          {
            current.legal_entity_type === USER_TYPE.INDIVIDUAL_ENTREPRENEUR
              ? (
                <Row className="row-cols-2">
                  {infoFormatterIntl('address', current.office_address, formMeta, 'office_address')}
                  {infoFormatterIntl('address_registration_entrepreneur', current.address, formMeta, 'address')}
                </Row>
              ) : (
                <Row className="row-cols-1">
                  {infoFormatterIntl('registration_address', current.address, formMeta, 'address')}
                </Row>
              )
          }
        </>
      )}
    </>
  );
}
